<ada-container
	#MainContainer
	id="MainContainer"
	[horizontalSpacing]="'Medium'"
	[padding]="_widgetService.ui.Spacing.SPACING_LARGE"
	[verticalSpacing]="'Medium'"
>
	<ada-container
		#Container2
		id="Container2"
		[colCount]="0"
		[horizontalSpacing]="'Small'"
		[verticalAlignmentOfChildren]="'Middle'"
	>
		<ada-text
			#IntervalSetting
			id="IntervalSetting"
			[content]="'Interval Setting'"
			[fontWeight]="'Bold'"
		/>
		<ada-signpost
			#Signpost1
			id="Signpost1"
			[icon]="'faInfoCircleOutline'"
		>
			<ada-text
				#TipText
				id="TipText"
				[content]="'Please enter a number of days, hours or minutes as the Schedule Interval.'"
			/>
		</ada-signpost>
	</ada-container>
	<ada-container
		#Container1
		id="Container1"
		[colCount]="4"
		[horizontalSpacing]="'Small'"
	>
		<ada-text
			#IntervalInputLabel
			id="IntervalInputLabel"
			[content]="'Recurring Interval'"
			[responsiveConfiguration]="_widgetService.ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-time-scale
			data-testid="reccuring-interval-time-scale"
			[isDisabled]="isDisabled"
			[responsiveConfiguration]="_widgetService.ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			[scaleConfiguration]="executionTimeScaleConfig"
			[value]="schedule?.recurrenceIntervalInMilliseconds"
			(valueChange)="setTimeScale($event)"
		/>
	</ada-container>
</ada-container>
